import {useEffect, useState} from 'react';
import {MapContainer, Marker, Popup, TileLayer} from 'react-leaflet';

import MapResizeZoom from "./MapResizeZoom";
import {MarkerIcon} from "./icons";
import {CARTO_TILE_URL, CARTO_TILE_OPTIONS} from 'core/mapsConfig';


const MapPoint = ({center}) => {
    const ZOOM = 14;
    const [position, setPosition] = useState(center);
    const [show, setShow] = useState(false);

    useEffect(() => {
        setPosition(center);
        setShow((center.length && center[0] && center[1]));
    }, [center]);

    return (
        show ?
            <MapContainer
                center={position}
                zoom={ZOOM}
                scrollWheelZoom={false}
                style={{width: '100%', height: '300px', zIndex: '2'}}
            >
                <MapResizeZoom position={position} zoomDefault={ZOOM}/>
                <TileLayer
                    url={CARTO_TILE_URL}
                    {...CARTO_TILE_OPTIONS}
                />
                <Marker position={position} icon={MarkerIcon}>
                    <Popup>
                        <div>
                            <p>Coordenadas: {position[0]}, {position[1]}</p>
                        </div>
                    </Popup>
                </Marker>
            </MapContainer>
            : <></>
    )
}

export default MapPoint;
